@if (isLoading) {
  <app-rings-loader></app-rings-loader>
}
<div class="modal-header">
  <h3 class="dialog-title text-center">{{ title }}</h3>
</div>
<div mat-dialog-content>
  <div class="modal-content">
    <div class="logo-img-container">
      <img src="assets/images/grpLogo.svg" alt="" class="logo-img">
    </div>
    <app-progress-spinner [show]="isFormLoading"></app-progress-spinner>
    <div class="modal-body">
      <div>
        @if (canUseTemplates && availableTemplates.length > 0) {
          <div class="template-selector">
            <mat-form-field appearance="outline" class="template-selector__field">
              <mat-label>{{ 'Apply Template' | translate }}</mat-label>
              <mat-select [value]="selectedTemplateId" (valueChange)="onTemplateSelected($event)">
                <mat-option [value]="null">{{ 'None' | translate }}</mat-option>
                @for (template of availableTemplates; track trackByEntityId($index, template)) {
                  <mat-option [value]="template.id">{{ template.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (isDefaultTemplateBannerVisible) {
              <div class="template-default-banner">
                <span class="template-default-banner__text">
                  <i class="material-icons">star</i>
                  {{ 'Default template applied' | translate }}
                </span>
                <button type="button" class="template-default-banner__clear" (click)="clearTemplateFields()">
                  {{ 'Clear' | translate }}
                </button>
              </div>
            }
          </div>
        }
        <div class="form-fields-body">
          <div class="row">
            @for (field of fields; track trackByIndex($index)) {
              <app-dynamic-form-field [field]="field" [entity]="entity" [templateState]="templateFieldStates.get(field.property)" (valueChanged)="onFieldValueChanged(field)"></app-dynamic-form-field>
            }
          </div>
        </div>
        <div class="survey-dialog-footer">
          @if (canUseTemplates) {
            <button type="button" mat-stroked-button class="survey-dialog-footer__template" [disabled]="isSavingTemplate || !entity?.organizationLevelId" (click)="onSaveTemplateClick()">
              <mat-icon>bookmark_add</mat-icon>
              {{ saveTemplateLabel | translate }}
            </button>
          }
          <div class="survey-dialog-footer__main">
            <button type="button" mat-button (click)="close()">{{ closeButtonText }}</button>
            @if (isTemplateEdit) {
              <button type="button" class="custom-main-btn" [class.cursor-not-allowed]="isLoading" [disabled]="!isTemplateDirtyState || isLoading" (click)="save()">
                {{ 'Save Changes' | translate }}
              </button>
            } @else if (!isReadonly) {
              <button type="button" class="custom-main-btn" [class.cursor-not-allowed]="isLoading" [disabled]="cachedDisabled" (click)="mainButtonClick()">
                {{ mainButtonText }}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
